import Vue from 'vue';
import VueI18n from 'vue-i18n';

import messages from './messages';

Vue.use(VueI18n);

// Create VueI18n instance with options
export default new VueI18n({
  locale: 'nl', // set locale
  fallbackLocale: 'en',
  messages, // set locale messages
});



// WEBPACK FOOTER //
// ./src/i18n/index.js